import styled from "@emotion/native";

export const Container = styled.View({});

export const Main = styled.View(
	{
		paddingTop: 16,
		paddingHorizontal: 12,
		marginTop: -3,
		marginBottom: -4,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.enabled,
		};
	}
);
